import { Box, Typography } from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import useTrashablePromises from "hooks/useTrashablePromises";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import {
  SaveResponse,
  SaveRoleRequest,
} from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import RoleForm, { RoleFormValues } from "./RoleForm";

const CreateRole = () => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { roleService, roleDetailsUrl, rolesUrl } = useGlobalContext();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useTitle(t({ id: "newRole" }));

  const onSubmit = async (values: RoleFormValues) => {
    try {
      const createdRole: SaveResponse = await registerPromise(
        roleService.saveRole(SaveRoleRequest.fromJS(values))
      );

      queryClient.invalidateQueries("roles");

      createdRole?.id && navigate(roleDetailsUrl(createdRole.id));

      return createdRole;
    } catch (err: any) {
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <Box my={2}>
        <RedirectBackButton
          redirectRoute={rolesUrl()}
          labelKey="backToListButtonLabel"
        />
      </Box>
      <Typography variant="h5">
        <T id="newRole" />
      </Typography>
      <RoleForm
        onSubmit={onSubmit}
        submitLabel={t({ id: "createRole" })}
        onCancel={() => navigate(rolesUrl())}
      />
    </>
  );
};

export default CreateRole;
